import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["disabled", "data-cy"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_registration_add = _resolveComponent("tickets-registration-add")!

  return ($setup.adding)
    ? (_openBlock(), _createBlock(_component_tickets_registration_add, {
        key: 0,
        seats: $props.viewProperties.availableSeats,
        onCancel: _cache[0] || (_cache[0] = ($event: any) => ($setup.adding = false)),
        onSave: $setup.saveReservation
      }, null, 8, ["seats"]))
    : (_openBlock(), _createElementBlock("nav", _hoisted_1, [
        _createElementVNode("button", {
          class: "round primary",
          disabled: $props.viewProperties.fullyBooked,
          "data-cy": `anmelden_${$props.viewProperties.game.uid}`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.adding = true))
        }, "Reservieren", 8, _hoisted_2)
      ]))
}